import { useMutation, useQuery } from "@tanstack/react-query";
import { volunteerApiService } from "modules/Volunteer/MasterVolunteer/api/volunteer.api";
import { VolunteerSelectAllParams, VolunteerTestRequest } from "modules/Volunteer/MasterVolunteer/helper/volunteer.types";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statusCode: number;
}

// ------------------------------------------------------------------
//-- Volunteer
// ------------------------------------------------------------------

export const useVolunteerService = ({
  otherid,
  searchText,
  volunteertype,
  pageNumber = 1,
  pageSize = 10,
  id,
  gender,
  smoker,
  min_age,
  max_age,
  minbmi,
  maxbmi,
  // alcohol,
  alcoholresult,
  bloodgroup,
  educationlevel,
  foodhabit,
  city,
  screeningstatus,
  screeningfromdate,
  screeningtodate,
  enableSelectAll = false,
  studyid,
  getDashboard = false
}: VolunteerSelectAllParams & { enableSelectAll?: boolean, getDashboard?:boolean}) => {
  const SelectAllQuery = useQuery({
    queryKey: [
      "volunteer-selectAll",
      {
        otherid,
        searchText,
        pageNumber,
        pageSize,
        gender,
        smoker,
        min_age,
        max_age,
        minbmi,
        maxbmi,
        alcoholresult,
        bloodgroup,
        educationlevel,
        foodhabit,
        city,
        screeningstatus,
        screeningfromdate,
        screeningtodate,
        studyid,
        volunteertype
      },
    ],
    queryFn: () =>
      volunteerApiService.getSelectAllData({
        searchText,
        volunteertype,
        pageNumber,
        pageSize,
        gender,
        smoker,
        min_age,
        max_age,
        minbmi,
        maxbmi,
        // alcohol,
        alcoholresult,
        bloodgroup,
        educationlevel,
        foodhabit,
        city,
        screeningstatus,
        screeningfromdate,
        screeningtodate ,
        studyid
      }),
    enabled: enableSelectAll && !!(pageNumber && pageSize),
  });

  const SelectQuery = useQuery({
    queryKey: ["volunteer-select", id],
    queryFn: () => volunteerApiService.getSelectData(id!),
    enabled: !!id,
  });

  const DashboardSelectQuery = useQuery({
    queryKey: ["volunteer-dashboard-select", id],
    queryFn: () => volunteerApiService.getDashboardSelect(id!),
    enabled: getDashboard && !!id,
  });

  const InsertMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => volunteerApiService.insertData(payload),
  });

  const UpdateMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => volunteerApiService.updateData(payload),
  });

  const DeleteMutation = useMutation<
    ApiResponse,
    Error,
    { volunteerid: number | null; updatereason: string }
  >({
    mutationFn: (payload) =>
      volunteerApiService.deleteData({
        volunteerid: payload.volunteerid,
        updatereason: payload.updatereason,
      }),
  });


  return {
    SelectAllQuery,
    SelectQuery,
    DashboardSelectQuery,
    InsertMutation,
    UpdateMutation,
    DeleteMutation,
  };
};



